import { memo, useContext, useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import GUIDELINE_RULES from 'constants/guidelineRules';
import Button from 'components/button';
import TextInput from 'components/textInput';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import CampaignFormField from '../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import TextArea from 'components/textArea';

const SubtitleFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const subtitleMiddle = useFieldArray({
    control: guidelineRuleFormMethods.control,
    name: 'SUBTITLE_MIDDLE',
  });

  return (
    <CampaignFormFieldGroup
      wrapperClassName="!gap-[30px]"
      label={`3. ${languageTexts.create_reels_form_subtitle}`}
      bordered
    >
      <div className="flex flex-col gap-[50px]">
        {/* 1초 후킹멘트 (선택) */}
        <CampaignFormField
          label={`${GUIDELINE_RULES.GetOptionTranslationMap(GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.SUBTITLE_OPENING)} (${
            languageTexts.select
          })`}
        >
          {/* <TextInput
            bordered
            placeholder={
              languageTexts.create_reels_form_subtitle_opening_placeholder
            }
            register={guidelineRuleFormMethods.register(
              'SUBTITLE_OPENING.value',
            )}
          /> */}
          <TextArea
            bordered
            placeholder={languageTexts.create_reels_form_subtitle_opening_placeholder}
            register={guidelineRuleFormMethods.register('SUBTITLE_OPENING.value')}
            autoResize={true}
            inputStyle={{
              display: 'block',
              paddingTop: '12px',
              paddingBottom: '12px',
            }}
          />
        </CampaignFormField>

        {/* 성능/효과/사용법 (선택) */}
        <div className="flex flex-col gap-2.5">
          <CampaignFormField
            as="ul"
            wrapperClassName="!gap-2.5"
            label={`${GUIDELINE_RULES.GetOptionTranslationMap(GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.SUBTITLE_MIDDLE)} (${
              languageTexts.select
            })`}
          >
            {/* {subtitleMiddle.fields.map((_field, index) => (
              <li key={`subtitle-middle-form-filed${index}`}>
                <TextInput
                  bordered
                  placeholder={languageTexts.create_reels_form_subtitle_middle_placeholder}
                  register={guidelineRuleFormMethods.register(`SUBTITLE_MIDDLE.${index}.value`)}
                  icon={
                    index > 0 && {
                      position: 'right',
                      icon: (
                        <div className="flex w-full h-full justify-center mr-[13px]">
                          <img
                            className="w-[22px] h-[22px] cursor-pointer my-auto"
                            src="/assets/icons/ic-close-black-squared.svg"
                            onClick={() => subtitleMiddle.remove(index)}
                          />
                        </div>
                      ),
                    }
                  }
                />
              </li>
            ))} */}
            {subtitleMiddle.fields.map((_field, index) => (
              <li key={`subtitle-middle-form-filed${index}`}>
                <TextArea
                  bordered
                  placeholder={languageTexts.create_reels_form_subtitle_middle_placeholder}
                  register={guidelineRuleFormMethods.register(`SUBTITLE_MIDDLE.${index}.value`)}
                  autoResize={true}
                  inputStyle={{
                    display: 'block',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                  }}
                  icon={
                    index > 0 && {
                      position: 'right',
                      icon: (
                        <div className="flex w-full h-full justify-center mr-[13px]">
                          <img
                            className="w-[22px] h-[22px] cursor-pointer my-auto"
                            src="/assets/icons/ic-close-black-squared.svg"
                            onClick={() => subtitleMiddle.remove(index)}
                          />
                        </div>
                      ),
                    }
                  }
                />
              </li>
            ))}
          </CampaignFormField>
          {subtitleMiddle?.fields?.length < 100 && (
            <Button
              className="border-1 border-gray-200 hover:border-black text-center py-3"
              justify={'center'}
              text={`${languageTexts.add2} +`}
              onClick={() =>
                subtitleMiddle.append({
                  value: '',
                })
              }
            />
          )}
        </div>

        {/* 행사 및 이벤트 (선택) */}
        <CampaignFormField
          label={`${GUIDELINE_RULES.GetOptionTranslationMap(GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.SUBTITLE_CLOSING)} (${
            languageTexts.select
          })`}
          description={languageTexts.create_reels_form_subtitle_closing_desc}
        >
          {/* <TextInput
            bordered
            placeholder={languageTexts.create_reels_form_subtitle_closing_placeholder}
            register={guidelineRuleFormMethods.register('SUBTITLE_CLOSING.value')}
          /> */}
          <TextArea
            bordered
            placeholder={languageTexts.create_reels_form_subtitle_closing_placeholder}
            register={guidelineRuleFormMethods.register('SUBTITLE_CLOSING.value')}
            autoResize={true}
            inputStyle={{
              display: 'block',
              paddingTop: '12px',
              paddingBottom: '12px',
            }}
          />
        </CampaignFormField>
      </div>
    </CampaignFormFieldGroup>
  );
};

export default memo(SubtitleFieldGroup);
